import  * as component  from './components'
export default [
    {
      name: 'managementreport.phishingvulnerability',
      path: '/managementreport/phishingvulnerability',
      component: component.PhishingVulnerabilityTrend,
    },
    {
      name: 'managementreport.awarenesstrendslook',
      path: '/managementreport/awarenesstrendslook',
      component: component.AwarenessTrendsLook,
    },
    {
      name: 'managementreport.reportingtrend',
      path: '/managementreport/reportingtrend',
      component: component.ReportingTrend,
    },
    {
      name: 'managementreport.weakest',
      path: '/managementreport/weakest',
      component: component.Weekest,
    },
    {
      name: 'managementreport.strongest',
      path: '/managementreport/strongest',
      component: component.Strongest,
    },
    {
      name: 'managementreport.departmentweakest',
      path: '/managementreport/departmentweakest',
      component: component.Deparmentweakest,
    },
    {
      name: 'managementreport.highrisk',
      path: '/managementreport/highrisk',
      component: component.Highrisk,
    },
    {
      name: 'managementreport.departmentcompromise',
      path: '/managementreport/departmentcompromise',
      component: component.Deparmentcompromise,
    },
     {
      name: 'managementreport.designationcompromise',
      path: '/managementreport/designationcompromise',
      component: component.Designationcompromise,
    },
     {
      name: 'managementreport.phishingvulnerabilitytrend',
      path: '/managementreport/phishingvulnerabilitytrend',
      component: component.phishingvulnerabilitytrend,
    },
    {
      name: 'managementreport.cybersecurityawarenesstrend',
      path: '/managementreport/cybersecurityawarenesstrend',
      component: component.cybersecurityawarenesstrend,
    },
    {
      name: 'managementreport.phishingreportingtrend',
      path: '/managementreport/phishingreportingtrend',
      component: component.phishingreportingtrend,
    },
    {
      name: 'managementreport.weakestlinks',
      path: '/managementreport/weakestlinks',
      component: component.WeekestLinkNew,
    },
    {
      name: 'managementreport.strongestlinks-least-compromised',
      path: '/managementreport/strongestlinks-least-compromised',
      component: component.StrongestLinkNew,
    },
     {
      name: 'managementreport.strongestlinks-most-reported',
      path: '/managementreport/strongestlinks-most-reported',
      component: component.StrongestLinkReported,
    },
    {
      name: 'managementreport.weakest_deparment_new',
      path: '/managementreport/weakest_deparment_new',
      component: component.DeparmentWeakestLink,
   },
    {
      name: 'newreports.VulnerabilityReport-DepartmentWiseUniqueEmployees',
      path: '/newreports/VulnerabilityReport-DepartmentWiseUniqueEmployees',
      component: component.VulnerabilityReportDepartmentWise,
    },
    {
      name: 'newreports.VulnerabilityReport-DesignationWiseUniqueEmployees',
      path: '/newreports/VulnerabilityReport-DesignationWiseUniqueEmployees',
      component: component.VulnerabilityReportDesignationWise,
    },
    {
      name: 'managementreport.weakestdepartments',
      path: '/managementreport/weakestdepartments',
      component: component.Weakestdepartments,
    },
    {
      name: 'managementreport.repeatoffenders',
      path: '/reports/repeatoffenders',
      component: component.RepeatOffenders,
    } 
]



// WEBPACK FOOTER //
// ./src/app/managementreport/routes/index.js